import { cacheLereRecommendations } from 'actions/RecommendationActions'
import { useEffect } from 'react'

import { useAppDispatch } from 'hooks/reduxHooks'
import debounce from 'lodash.debounce'
import { Dispatch } from 'redux'

const debouncedCacheCalendar = debounce((op: 'dispatch' | 'cancel', dispatch: Dispatch<any>, offer: App.Offer, duration?: number, rooms?: App.Occupants[]) => {
  if (op === 'dispatch') {
    dispatch(cacheLereRecommendations(offer.id, { duration, rooms }))
  }
}, 500)

function useDispatchPrecacheLere(ready: boolean, offer: App.Offer, duration?: number, rooms?: App.Occupants[]) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (ready) {
      debouncedCacheCalendar('dispatch', dispatch, offer, duration, rooms)
    } else {
      debouncedCacheCalendar('cancel', dispatch, offer, duration, rooms)
    }
    return () => {
      debouncedCacheCalendar('cancel', dispatch, offer, duration, rooms)
    }
  }, [dispatch, offer, duration, rooms, ready])
}

export default useDispatchPrecacheLere
